import React, { useState } from "react";
import { EditPaymentMethod } from "../../pages";
import { TransactionsController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import * as yup from "yup";

const EditPaymentMethodContainer = ({ closeModal, selectedItem }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    methods: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required("Method name is required"),
          requiredFields: yup
            .array()
            .of(yup.string().required("Required field cannot be empty"))
            .min(1, "At least one required field is needed"),
        })
      )
      .min(1, "At least one method is required"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      methods: values.methods,
    };
    const { status, errorMessage } =
      await TransactionsController.editPaymentMethod(payload, selectedItem._id);
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);

    return closeModal();
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];
  return (
    <EditPaymentMethod
      closeModal={closeModal}
      currencyCodes={currencyCodes}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
      selectedItem={selectedItem}
    />
  );
};

export default EditPaymentMethodContainer;
